export default __webpack_public_path__ + "static/media/location_icon.d92aaadf.svg";